export default __webpack_public_path__ + "static/media/teams-card-img-5.bdf95ecf.png";